import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { history } from '../../state/store';

const IconValue = ({label,size, value, unit, icon, color, detailedRoute}) => {

	function handleRouting() {
		let type = "/10";

		if(label === "Hőmérséklet") {
			type = "/11";
		}else if(label === "Pára") {
			type = "/12";

		}else if(label === "PM10") {
			type = "/10";
		}

		history.push(detailedRoute + type)
	}

    return (
       <div className={'icon-value widget justify-content-center align-items-center '+ size } onClick={handleRouting}>
       	<div className="display justify-content-center align-items-center">
       	<i className="icon" style={{color:color}} >
			{ icon && <FontAwesomeIcon icon={['fal', icon]} />}
       	</i>
       	<div className="value">{value} {unit}</div>
       	</div>
       	<span>{label}</span>
       </div>
    );
};

IconValue.propTypes = {};

export default IconValue;